export default __webpack_public_path__ + "static/c-news-224a8e2dbf638ed4014e6cfa16007186.jpg";